const Dropdown = ({ tabs, onTabSelect, selectedTab }) => {
  return (
    <div class="dropdown dropdown-dark">
      <select
        name="two"
        class="dropdown-select"
        value={selectedTab}
        onChange={(event) => onTabSelect(event.target.value)}
      >
        {tabs.map(({ id, path, label }) => (
          <option key={id} id={`tab-option-${id}`} value={path}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
